module.exports = __webpack_public_path__ + "img/help-icon.983b3be0.png";